import { render, staticRenderFns } from "./RiskFactors.vue?vue&type=template&id=d609528e&scoped=true&"
import script from "./RiskFactors.vue?vue&type=script&lang=js&"
export * from "./RiskFactors.vue?vue&type=script&lang=js&"
import style0 from "./RiskFactors.vue?vue&type=style&index=0&id=d609528e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d609528e",
  null
  
)

export default component.exports